// extracted by mini-css-extract-plugin
export var svgAmber = "b3_jR";
export var svgBlack = "b3_jP";
export var svgBlue = "b3_jL";
export var svgDarkBlue = "b3_jH";
export var svgDarkGreen = "b3_jJ";
export var svgGreen = "b3_jK";
export var svgLightBlue = "b3_jM";
export var svgRed = "b3_jQ";
export var svgWhite = "b3_jN";